import React from 'react'
import { Navigate } from 'react-router-dom'
import ProtectedRequest from 'src/services/ProtectedRequest/ProtectedRequest'
import { useMsal } from '@azure/msal-react'
import { InteractionStatus } from '@azure/msal-browser'
import { CircularProgress, Box } from '@mui/material'
import { accountMatchesRealm } from 'src/config/msalConfig'
import { loginPathForCurrentEnv } from 'src/config/environments'

export const ProtectedRoute = ({ children }) => {
  const { accounts, inProgress } = useMsal()

  // Authenticated ONLY if there is an account for the current environment's
  // tenant. The MSAL cache is shared across environments, so a plain
  // useIsAuthenticated() would be true with a leftover account from another
  // env and let the user in while every API call 403s.
  const authedForRealm = accounts.some(accountMatchesRealm)

  // Wait for MSAL to finish initializing before making routing decisions.
  if (inProgress !== InteractionStatus.None) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  if (!authedForRealm) {
    return <Navigate to={loginPathForCurrentEnv()} replace />
  }

  return <ProtectedRequest>{children}</ProtectedRequest>
}
